<template>
  <div id="basicInfo">
    <p class="title">消息</p>
    <div class="messagesCon">
      <ul>
        <li v-if="mesList.length == 0">您还没有任何消息哟</li>
        <li style="cursor: pointer" v-for="item in mesList" @click="messagesCb(item)">
          <el-badge is-dot class="item" v-if="item.status == 0">
          </el-badge>
          <div class="titleMesscon">
            <b v-if="item  .msg_type == 'reject'" style="color: #f00">[&nbsp;&nbsp;<span style="position: relative;top: 1px;">{{ item.title }}</span>&nbsp;&nbsp;]</b>
            <b v-else class="messTitle">{{item | msg_type}}</b>
            <div>
              <span>作者：猎户技能平台</span>
              <span>日期：{{item.updated_at}}</span>
            </div>
          </div>
          <p>{{item.content}}</p>

        </li>
      </ul>
      <div class="block">
        <!--<el-pagination layout="prev, pager, next" :page-size="page.per_page" :total="page.total" @current-change="changePage"></el-pagination>-->
      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import config from '@/config/index'
  import commonMethods from '@/mixins/commonMethods'
  import {messagesListApi, messagesNewApi, getUserId, messagesCbApi} from '@/api'

  export default {
    mixins: [
      commonMethods
    ],
    data() {
      return {
        user_id: '',
        skill_id: '',
        mesList: []
      }

    },
    created() {
      this.getUserId()
    },
    methods: {
      async getUserId() {//获取用户id skillId
        let res = await getUserId()
        this.user_id = res.data.data.id
        this.skill_id = this.$route.query.skillId
        this.messagesList()
      },
      async messagesList() {
        let res = await messagesListApi(qs.stringify({user_id: this.user_id, page: 1}))
        if (res.data.code == 200) {
          this.mesList = res.data.data;
          this.getMessageNum(this.user_id);//同步新消息数量
        } else {
          this.$message.error('获取消息列表失败!')
        }
      },
      async getMessageNum(id) {
        let res = await messagesNewApi(qs.stringify({user_id: id}));
        if (res.data.code == 200) {
          let msg_num = Number(res.data.data.new_message_num);
          this.$store.dispatch('changeMessageNum',msg_num);
        }
      },
      async messagesCb(item) {
        let res = await messagesCbApi(qs.stringify({message_id: item.message_id}))
        if (res.data.code == 200) {
          item.status = 1;
          this.messagesList();
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #basicInfo {
    width: 100%;
    height: 100%;
    .title{
      height:64px;
      line-height:64px;
      padding-left:30px;
      font-weight: 800;
      font-size: 16px;
      color:#2e4d79;
      border-bottom:1px solid #f5f5f5;
      border-left:2px solid #010202;
    }
    .messagesCon {
      padding: 0;
      ul {
        width: 100%;
        list-style: none;
        font-size: 14px;
        li {
          position: relative;
          padding: 35px;
          background: #fff;
          border-bottom: 1px solid #f3f3f3;
          .titleMesscon {
            display: flex;
            padding-left: 15px;
            justify-content: space-between;
            padding-bottom: 20px;
            div {
              font-size: 12px;
              color: #dedede;
            }
          }
          p {
            text-indent: 27px;
          }
          .el-badge {
            position: absolute;
            top: 40px;
            left: 35px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/Messages.vue